import {NavigationButtonPosition} from "../../../core/model2/navigation/@const"
import NavigationSection from "../../../core/model2/navigation/navigation-section";
import {BUS_NAVIGATION_CHANGED} from "../@const";

// const debug = "navigation_setPosition"
const debug = false

export default function navigation_setPositionNew(navigationSection:NavigationSection, position: NavigationButtonPosition, calledBy?:string) {
    if (!navigationSection) return

    debug && console.log(debug, "id=", navigationSection.id)

    navigationSection.position = position

    // sorting (!) - save in save position
    gd.user.settings.navigation.spacesSorting = _.map(gd.spaces.navigationPanelSections, (section:NavigationSection)=>{
        return section.id
    })

    // save position
    gd.navigationStructure.savePositions()

    gd.layout.navigation.reRender(calledBy)

    debug && console.log(debug, 'process', gd.navigationStructure, gd.user.settings.navigation.buttonPositions)

    gd.bus.triggerEvent(BUS_NAVIGATION_CHANGED)
}
